import supabase from '../supabase/supabase';

function parseSelectedExtras(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  return [];
}

export async function loadQuoteAcceptance(quoteId) {
  console.log('Loading quote acceptance for quote UUID:', quoteId);

  const {data, error} = await supabase
    .from('quote_acceptances')
    .select('*')
    .eq('quote_id', quoteId)
    .single();

  if (error) {
    console.error('Supabase quote_acceptances query error:', error);
    throw error;
  }

  const acceptance = {
    ...data,
    selected_extras: parseSelectedExtras(data.selected_extras)
  };

  console.log('Returned quote_acceptances row:', data);
  console.log('Acceptance selected_extras:', acceptance.selected_extras);

  return acceptance;
}